module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Winter Blessings")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780310354369_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Family Tree"
    }
  }, [_c('p', {
    staticClass: "ftree",
    attrs: {
      "id": "P4_2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_286",
      "title": "286"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rP4_2"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftree1"
  }, [_vm._v("Featuring "), _c('i', [_vm._v("The Christmas Cat")]), _vm._v(" novella characters from the collection "), _c('i', [_vm._v("An Amish Christmas Love.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Thelma m. Alfred Bender")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Mandy")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Rhoda")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Leona m. Marlin Blank")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Darlene m. Uria Swarey")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Ephraim")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Katie Ann")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Emma m. Henry (deceased) Bontrager")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Hank the Cat")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Darlene m. Uria Swarey")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Savannah")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Rebekah")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Marietta m. Roman Hertzler")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Clara")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Gertrude m. Elvin King")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Wayne")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Feenie m. Jeptha Lantz")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Arlan")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Christian")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Saloma m. Floyd Petersheim")])]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Jerry")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Biena")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0309af04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310354369_Ftree_P4.vue
// module id = 72
// module chunks = 0